/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import 'cally';
import domtoimage from 'dom-to-image';
import "@js/parts/unpoly/index";
import "@js/parts/alpine/index";

// Make dom-to-image globally available
window.domtoimage = domtoimage;

// Only load HMR helpers in dev
if (import.meta.env.DEV) {
  import('./hmr.dev.js');
}
